<template>
  <div>
    <!-- snackbar -->
    <v-snackbar
      v-model="snackBar.showSnack"
      :timeout="snackBar.snackTimeout"
      :color="snackBar.snackColor"
      :top="snackBar.position"
    >
      <div v-show="false" class="v-menu__content--active" />
      <!-- This prevents dialogs closing when snackbar is clicked -->
      <div class="row">
        <div class="col">{{ snackBar.snackText }}</div>
        <v-btn
          v-if="snackBar.showCloseBtn"
          color="white"
          icon
          @click="snackBar.showSnack = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>
    <!-- bottom sheet -->
    <v-bottom-sheet v-model="bottomSheet.showSheet">
      <v-sheet class="text-center" height="400px">
        <!-- <v-btn
            class="mt-6"
            text
            color="red"
            @click="bottomSheet.showSheet = !bottomSheet.showSheet"
        >close</v-btn>-->
        <div class="py-3" style="max-height: 390px;overflow: auto;">
          <v-subheader>Validation Errors</v-subheader>
          <v-list
            v-for="verr in bottomSheet.validationMessages"
            :key="verr.title"
            class="pt-0 pb-0"
          >
            <!-- <v-subheader v-if="verr.subheader">{{verr.subheader}}</v-subheader> -->

            <v-list-item style="border-top:0.5px solid silver">
              <v-avatar size="32px" tile>
                <v-icon>{{ returnIconType(verr.type) }}</v-icon>
              </v-avatar>
              <v-list-item-title
                :class="'t-a-l pl-4 ' + returnColorType(verr.type) + '--text'"
                >{{ verr.message }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
          <v-subheader>Other Errors</v-subheader>
          <v-list
            v-for="verr in bottomSheet.errorMessages"
            :key="verr.title"
            class="pt-0 pb-0"
          >
            <!-- <v-subheader v-if="verr.subheader">{{verr.subheader}}</v-subheader> -->

            <v-list-item style="border-top:0.5px solid silver">
              <v-avatar size="32px" tile>
                <v-icon>{{ returnIconType(verr.type) }}</v-icon>
              </v-avatar>
              <v-list-item-title
                :class="'t-a-l pl-4 ' + returnColorType(verr.type) + '--text'"
                >{{ verr.message }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  // components:{Simplert},
  data() {
    return {
      valErrors: [],
      snackBar: {
        showSnack: false,
        snackTimeout: 3000,
        snackColor: "primary",
        snackText: "",
        showCloseBtn: true,
        position: "top",
      },
      bottomSheet: {
        showSheet: false,
        errorMessages: [],
        validationMessages: [],
      },
    };
  },
  created: async function() {},
  methods: {
    ManageResponse(response) {
      var self = this;
      this.bottomSheet.validationMessages = [];
      this.bottomSheet.errorMessages = [];
      switch (response.status) {
        case 403:
          self.showSnackBar(
            "You are not authorized to view this page or do this action",
            "error",
            5000
          );
          break;
        case 302:
          break;
        default:
          if (response.data) {
            if (response.data.errors) {
              if (response.data.errors.errors) {
                // handle snackBar
                if (response.data.errors.errors.length > 0) {
                  let em = [];
                  for (let ms of response.data.errors.errors) {
                    em.push(ms);
                  }
                  let m = em.join("\n");
                  let c = self.returnColorType("error");
                  self.showSnackBar(m, c, 5000);
                }
              }
            } else if (response.data.validationErrors) {
              // if (
              //   response.data.validationErrors.length > 0 ||
              //   response.data.errors.length > 0
              // ) {
              //   if (response.data.validationErrors.length > 0) {
              //     this.bottomSheet.validationMessages = [
              //       ...response.data.validationErrors,
              //     ];
              //   }
              //   if (response.data.errors.length > 0) {
              //     this.bottomSheet.errorMessages = [...response.data.errors];
              //   }
              //   this.bottomSheet.showSheet = true;
              // }
              if (response.data.validationErrors.length > 0) {
                for (
                  let i = 0;
                  i < response.data.validationErrors.errors.length;
                  i++
                ) {
                  if (response.data.validationErrors.errors[i].property != "") {
                    this.bottomSheet.validationMessages = [
                      ...response.data.validationErrors.errors[i].error,
                    ];
                  } else {
                    this.bottomSheet.errorMessages = [
                      ...response.data.validationErrors.errors[i].error,
                    ];
                  }
                }
              }
            } else if (response.data.message) {
              // self.showSnackBar(response.data.data, "primary", 5000);
              if (response.data.message.length > 0) {
                let em = [];
                for (let ms of response.data.message) {
                  em.push(ms.message);
                }
                let m = em.join("\n");
                let c = self.returnColorTypeById(
                  response.data.message[0].messageType
                );
                self.showSnackBar(m, c, 5000);
              }
            }
          }

          break;
      }
    },
    returnColorType(c) {
      switch (c) {
        case "info":
          return "primary";
        case "warn":
          return "orange";
        case "error":
          return "error";
        case "success":
          return "success";
        default:
          return "primary";
      }
    },
    returnColorTypeById(c) {
      switch (c) {
        case 0:
          return "primary";
        case 2:
          return "orange";
        case 99:
          return "error";
        case 1:
          return "success";
        default:
          return "primary";
      }
    },
    returnIconType(c) {
      switch (c) {
        case "info":
          return "mdi mdi-alert-circle-outline primary--text";
        case "warn":
          return "mdi mdi-alert-outline orange--text";
        case "error":
          return "mdi mdi-alert-outline error--text";
        case "success":
          return "mdi mdi-check-circle-outline success--text";
        default:
          return "primary--text";
      }
    },
    showSnackBar(text, color, timeout, closebtn) {
      if (text) {
        if (color) {
          this.snackBar.snackColor = color;
        }
        if (timeout) {
          this.snackBar.snackTimeout = timeout;
        }
        if (closebtn == false) {
          this.snackBar.showCloseBtn = false;
        }
        this.snackBar.snackText = text;
        this.snackBar.showSnack = true;
      }
    },
    ClearValidationErrors: function() {
      this.valErrors = [];
    },
  },
};
</script>
